'use client';

import { useEffect } from 'react';

/**
 * Silently triggers a background blog fetch when the home/landing page loads.
 * Does not block rendering or show UI.
 */
export function BlogAutoFetch() {
  useEffect(() => {
    fetch('/api/blog/auto-fetch', { method: 'POST' }).catch((error) => {
      console.warn('[BlogAutoFetch] Background fetch failed:', error);
    });
  }, []);

  return null;
}
